module.exports = __webpack_public_path__ + "img/vide3.05b32ec3.png";